@charset "UTF-8";

/* app/js/src/components/clipping-studio/panels/graphics-panel/fruit-icon-editor/clipping-studio-fruit-icon-editor.component.scss */
.cursor-pointer {
  cursor: pointer;
}
.fruit-icon-editor {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  background: rgb(255, 255, 255);
  border: none;
  box-shadow: none;
  display: flex;
  flex-direction: column;
  z-index: 20;
  font-family: "Open Sans", sans-serif;
}
.fruit-icon-editor__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 14px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.14);
}
.fruit-icon-editor__header-title {
  font-size: 14px;
  font-weight: 700;
  color: rgba(0, 0, 0, 0.85);
  margin: 0;
  font-family: "Open Sans", sans-serif;
}
.fruit-icon-editor__close-btn {
  background: none;
  border: none;
  font-size: 20px;
  color: rgba(0, 0, 0, 0.54);
  cursor: pointer;
  padding: 0 4px;
  line-height: 1;
}
.fruit-icon-editor__close-btn:hover {
  color: rgba(0, 0, 0, 0.85);
}
.fruit-icon-editor__body {
  flex: 1;
  overflow-y: auto;
  padding: 14px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.fruit-icon-editor__section {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.fruit-icon-editor__label {
  font-family: "Open Sans", sans-serif;
  font-size: 11px;
  font-weight: 700;
  color: rgba(0, 0, 0, 0.35);
  text-transform: uppercase;
}
.fruit-icon-editor__grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 8px;
}
.fruit-icon-editor__icon-btn {
  aspect-ratio: 1;
  padding: 6px;
  border: 1px solid rgba(0, 0, 0, 0.14);
  border-radius: 6px;
  background: rgb(255, 255, 255);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 0;
}
.fruit-icon-editor__icon-btn:hover {
  border-color: rgb(45, 187, 252);
  background: rgba(45, 187, 252, 0.06);
}
.fruit-icon-editor__icon-btn--selected {
  border-color: rgb(45, 187, 252);
  background: rgba(45, 187, 252, 0.12);
}
.fruit-icon-editor__icon-img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.fruit-icon-editor__time-row {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-direction: column;
}
.fruit-icon-editor__time-input-wrap {
  display: flex;
  align-items: center;
  gap: 6px;
  width: 100%;
  min-width: 0;
}
.fruit-icon-editor__time-input {
  flex: 1;
  min-width: 0;
  padding: 6px 8px;
  font-size: 12px;
  font-family: monospace;
  border: 1px solid rgba(0, 0, 0, 0.14);
  border-radius: 6px;
}
.fruit-icon-editor__time-now-btn {
  flex-shrink: 0;
  padding: 6px 10px;
  font-size: 11px;
  font-weight: 600;
  color: rgb(45, 187, 252);
  background: transparent;
  border: 1px solid rgba(0, 0, 0, 0.14);
  border-radius: 6px;
  cursor: pointer;
  white-space: nowrap;
}
.fruit-icon-editor__time-now-btn:hover {
  background: rgba(45, 187, 252, 0.08);
}
.fruit-icon-editor .fruit-icon-editor__scale-row {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  min-width: 0;
}
.fruit-icon-editor .fruit-icon-editor__slider {
  flex: 1;
  min-width: 0;
  height: 8px;
  -webkit-appearance: none;
  appearance: none;
  background: transparent;
  border: none;
  outline: none;
}
.fruit-icon-editor .fruit-icon-editor__slider::-webkit-slider-runnable-track {
  height: 4px;
  background: #e1e6eb;
  border: 1px solid rgba(0, 0, 0, 0.14);
  border-radius: 2px;
}
.fruit-icon-editor .fruit-icon-editor__slider::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: rgb(45, 187, 252);
  border: 2px solid rgb(255, 255, 255);
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.14);
  cursor: pointer;
  margin-top: -6px;
}
.fruit-icon-editor .fruit-icon-editor__slider::-moz-range-track {
  height: 4px;
  background: #e1e6eb;
  border: 1px solid rgba(0, 0, 0, 0.14);
  border-radius: 2px;
}
.fruit-icon-editor .fruit-icon-editor__slider::-moz-range-thumb {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: rgb(45, 187, 252);
  border: 2px solid rgb(255, 255, 255);
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.14);
  cursor: pointer;
}
.fruit-icon-editor .fruit-icon-editor__number {
  width: 70px;
  padding: 6px 6px;
  font-size: 12px;
  font-family: "Open Sans", sans-serif;
  border: 1px solid rgba(0, 0, 0, 0.14);
  border-radius: 6px;
  box-sizing: border-box;
}
.fruit-icon-editor__footer {
  padding: 12px 14px;
  border-top: 1px solid rgba(0, 0, 0, 0.14);
}
.fruit-icon-editor__save-btn {
  width: 100%;
  padding: 8px 14px;
  font-size: 12px;
  font-weight: 700;
  border: none;
  border-radius: 6px;
  background: rgb(45, 187, 252);
  color: rgb(255, 255, 255);
  cursor: pointer;
  font-family: "Open Sans", sans-serif;
}
.fruit-icon-editor__save-btn:hover {
  opacity: 0.9;
}
/*# sourceMappingURL=clipping-studio-fruit-icon-editor.component.css.map */
